import React from "react";

/** @jsx jsx */
import { jsx, css } from '@emotion/react';

const PRIVACY_URL = "https://privacy.autoimmunegame.com";

const privacyWarningStyle = css`
    font-size: 1vw;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    max-width: 22vw;
    line-height: 1.4;
    margin-top: 2vh;
    a {
        color: rgba(255, 255, 255, 0.95);
        text-decoration: underline;
        &:hover {
            color: white;
        }
    }
`;
export const isDesktopChrome = () => {
    const agent = navigator.userAgent;
    const isChrome = /Chrome\//.test(agent) && !/Edg\/|OPR\/|SamsungBrowser/.test(agent);
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/.test(agent);
    return isChrome && !isMobile;
};

const privacyLinkStyle = css`
    font-size: 11px;
    margin-top: 2vh;
    a {
        color: rgba(255, 255, 255, 0.5);
        text-decoration: underline;
        &:hover {
            color: white;
        }
    }
`;

export const P2PPrivacyWarning = () => (
    <div css={privacyWarningStyle}>
        This service uses a direct peer-to-peer connection to the other player,
        which requires sharing your IP address with the other player and our servers.
        {' '}
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
            Learn more in our Privacy Policy.
        </a>
    </div>
);

export const DesktopChromeHostNotice = () => (
    <div css={css`
        font-size: 0.8em;
        margin-top: 0.5vw;
        line-height: 1.3;
    `}>
        This link works best in desktop Chrome. Phones and other browsers may not be able to connect.
    </div>
);

export const DesktopChromeJoinerNotice = () => (
    <div css={css`line-height: 1.3;`}>
        This game connects best in desktop Chrome. On this browser the connection may fail -
        open the link there if you run into trouble.
    </div>
);

export const PrivacyPolicyLink = () => (
    <div css={privacyLinkStyle}>
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
            Privacy Policy
        </a>
    </div>
);
